@if (!showSSOAccess && !ssoLogin) {
    <div (@flyInOut.done)="animationFinished()" [@flyInOut]="state" [hidden]="isHidden" class="login_bg">
        <div class="va-login-head">
            <!--<div class="va_logo">
              <img src="../../../../assets/VA_Logos/logo_black.svg" alt="">
            </div>-->

            <div class="login-text-intro">
                <div>Healthy Campus Login</div>
            </div>
        </div>
        <form (keyup.enter)="onLoginClicked()" [formGroup]="loginForm" novalidate data-cy="login-form"
              *ngIf="showEmailLogin">
            <div class="input_wrp">
                <label>Username</label>
                <div class="login_form_input login_padding hc-input">
                    <input
                            placeholder="{{ translate.stream('LOGIN.PLACEHOLDERS.USER_OR_EMAIL') | async }}"
                            class="login_img user_img form-control "
                            formControlName="username"
                            name="passwordForm"
                            aria-label="Enter username or email"
                            data-cy="login-form-input-email"
                            autocomplete="email"
                    />
                </div>
            </div>
            <div class="input_wrp">
                <label>Password</label>
                <div class="login_form_input login_padding hc-input">
                    <input
                            placeholder="{{ translate.stream('LOGIN.PLACEHOLDERS.PASS') | async }}"
                            [type]="isPwVisible ? 'text' : 'password'"
                            class="login_img pass_img form-control"
                            formControlName="password"
                            name="passwordForm"
                            type="password"
                            aria-label="Enter password"
                            data-cy="login-form-input-password"
                            autocomplete="current-password"
                    />
                    <i
                            (click)="togglePasswordVisible()"
                            [ngClass]="isPwVisible ? 'active' : 'unclicked'"
                            class="icon-pwd login_pass_eye_img"
                            data-cy="login-form-i-show-password"
                    ></i>
                </div>
            </div>
        </form>

        <div *ngIf="isSubmitted && showEmailLogin" class="login_error">
            {{ errorStr$ | async }}
        </div>

        <div class="login_form_ctrl">
            <div class="reset_pass_wrp" *ngIf="showEmailLogin">
                <div class="main_gray_ada fs-14 reset_pass_inner">
                    <mat-checkbox [(ngModel)]='isRememberMeEnabled'><span class="c4">Remember me</span></mat-checkbox>
                    <span class="c-p resetpass_link c4" (click)="onForgotPassword()"
                          data-cy="login-div-forget-password">{{ translate.stream('LOGIN.RESET_PASS') | async }}</span>
                </div>
            </div>

            <!-- optional login -->
            <div class="mt-4" *ngIf="!showEmailLogin">
                <button class="sso hc-button-yellow" (click)="onSSOLogin()">Login with SSO</button>
            </div>

            <div class="or-continue-with" *ngIf="!showEmailLogin"><span>or</span></div>

            <div class="d-flex align-items-end">
                <div class="w-100" *ngIf="showEmailLogin" class="submitContainer">
                    <!-- Back button to go back to login options -->
                    <button class="hc-button-white" *ngIf="showEmailLogin" (click)="toggleShowEmailLogin()">
                        <mat-icon>keyboard_backspace</mat-icon>
                        Back
                    </button>
                    <button class="hc-button-yellow w-100" (click)="onLoginClicked()" data-cy="login-button-login">
                        <ng-container *ngIf="!isLoggingIn">{{ translate.stream('LOGIN.LOGIN') | async }}</ng-container>
                        <ng-container *ngIf="isLoggingIn">
                            <app-button-loading-spinner></app-button-loading-spinner>
                        </ng-container>
                    </button>
                </div>

                <!-- Show email login container -->
                <button class="btn btn-act btn-xxl va-btn-bg w-100 btn-login-with-email" (click)="onLoginClicked()"
                        data-cy="login-button-login" *ngIf="!showEmailLogin" (click)="toggleShowEmailLogin()">
                    <ng-container>Login with Email</ng-container>
                </button>

                <div hidden>
                    <button mat-button class="btn btn-act btn-xxl yellow-btn w-100" (click)="onJakLogin()"
                            data-cy="login-button-sms-login">{{ 'PATIENT_OVERVIEW.SMS_LOGIN' | translate }}
                    </button>
                </div>
            </div>
        </div>

        <!--  <div class="dont-have-an-account">-->
        <!--    <div class="c5">Don't have an account? <a class="signup-now" href="http://">Sign Up Now</a></div>-->
        <!--  </div>-->

        <!-- Register -->
        <ng-container *ngIf="showRegister">
            <div class="login_new_label_container">
                <div class="login_new_label">
                    <hr class="login_hr_left"/>
                    {{ labels?.registerTitle }}
                    <hr class="login_hr_right"/>
                </div>
            </div>
            <div class="login_register" (click)="onCreateAccount()" routerLink="/profile/1"
                 data-cy="login-div-label-register">
                {{ labels?.register }}
            </div>
        </ng-container>

    </div>
}
<mat-progress-bar *ngIf="ssoLogin && !showSSOAccess" mode="indeterminate"></mat-progress-bar>
@if (showSSOAccess && ssoLogin) {
    <app-permission-request [isEmptyState]="isEmptyState" (submitEvent)="onSubmit($event)">
    </app-permission-request>
}
